import React from "react";
import { Caixa } from "../../models/caixa";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import { IndicadorFlat } from "../../components/Indicador";
import { AntTab, AntTabs, TabPanel } from "../../components/TabPanel";
import Typography from "@material-ui/core/Typography";
import { ListItemProduto } from "./ListItemProduto";
import { ListItemCombustivel } from "./ListItemCombustivel";
import { ListItemFormaPgto } from "./ListItemFormaPgto";
import { ListItemBico } from "./ListItemBico";
import { DonutChart } from "../../charts/DonutChart";
import { BarChart } from "../../charts/BarChart";
import { getCombustivelDefBySigla } from "../../models/combustivel";
import { ListItemVendedor } from "./ListItemVendedor";
import { ListItemGrupoProduto } from "./ListItemGrupoProduto";
import {
  convertVendaCombustivelToVenda,
  convertVendaGrupoProdutoToVenda,
  convertVendaProdutoToVenda,
  convertVendaVendedorToVenda,
} from "../../models/venda";
import { colors } from "@material-ui/core";
export const CaixaDetalhes = ({ caixa }: { caixa: Caixa }) => {
  const descricao = `E${caixa.empresaCod} Turno ${caixa.turno} ${caixa.operadorNome}`;

  const situacao = caixa.dataFechamento
    ? "Fechado às " + new Date(caixa.dataFechamento).toLocaleTimeString("pt-br")
    : "Aberto";

  const [tabIndex, setTabIndex] = React.useState(0);

  const handleTabsChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabIndex(newValue);
  };

  const graficoCombustiveisColorArray = caixa.vendasCombustiveis.map(
    (x) => getCombustivelDefBySigla(x.sigla!)?.cor ?? "",
  );

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        style={{
          height: "100%",
          display: "grid",
          gridTemplateRows: "auto minmax(0, 100%)",
          justifyContent: "stretch",
        }}
      >
        <Grid item xs={12}>
          <Typography variant="button" gutterBottom>
            {descricao}: {situacao}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "grid",
            gridTemplateRows: "auto minmax(0, 100%)",
          }}
        >
          <AntTabs
            value={tabIndex}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            onChange={handleTabsChange}
          >
            <AntTab label="Bicos" />
            <AntTab label="Combustíveis" />
            <AntTab label="Produtos" />
            <AntTab label="Grupos" />
            <AntTab label="Formas" />
            <AntTab label="Vendedor" />
          </AntTabs>

          <TabPanel value={tabIndex} index={0}>
            <Grid container justifyContent="center" spacing={4}>
              <Grid item>
                <IndicadorFlat
                  titulo="Liquido"
                  r$
                  valor={caixa.vendasBicos.reduce((a, b) => a + b.total, 0)}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="Quantidade"
                  lt
                  valor={caixa.vendasBicos.reduce(
                    (a, b) => a + b.quantidade,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="# Vendas"
                  valor={caixa.vendasBicos.reduce((a, b) => a + b.contagem, 0)}
                />
              </Grid>
            </Grid>

            <BarChart
              label="Por Bico"
              dados={caixa.vendasBicos.map((x) => ({
                name: x.bico.toString(),
                value: x.quantidade,
              }))}
              datasetOptions={{
                barThickness: 12,
                maxBarThickness: 10,
                barPercentage: 0.5,
                categoryPercentage: 0.5,
              }}
              colors={colors.indigo[800].toString()}
            />

            <List>
              {caixa.vendasBicos.map((x) => (
                <ListItemBico key={x.bico} {...x} />
              ))}
            </List>
            <Typography variant="caption" display="block" gutterBottom>
              EI=Encerrante Inicial e EF=Encerrante Final.{" "}
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              Ambos representam, respectivamente, o menor e maior encerrante
              movimentado neste caixa e nem sempre corresponderão ao valor real
              do encerrante na bomba no momento de abertura e fechamento deste
              caixa
            </Typography>
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Grid container justifyContent="center" spacing={4}>
              <Grid item>
                <IndicadorFlat
                  titulo="Liquido"
                  r$
                  valor={caixa.vendasCombustiveis.reduce(
                    (a, b) => a + b.totalLiquido,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="Quantidade"
                  lt
                  valor={caixa.vendasCombustiveis.reduce(
                    (a, b) => a + b.quantidade,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="# Vendas"
                  valor={caixa.vendasCombustiveis.reduce(
                    (a, b) => a + b.contagem,
                    0,
                  )}
                />
              </Grid>
            </Grid>

            <DonutChart
              dados={caixa.vendasCombustiveis.map((x) => ({
                name: x.produtoNome,
                value: x.quantidade,
              }))}
              showLegend={false}
              colorArray={graficoCombustiveisColorArray}
            />

            <List>
              {caixa.vendasCombustiveis.map((x) => (
                <ListItemCombustivel
                  key={x.produtoCod}
                  vendaCombustivel={convertVendaCombustivelToVenda(x)}
                />
              ))}
            </List>
          </TabPanel>

          <TabPanel value={tabIndex} index={2}>
            <Grid container justifyContent="center" spacing={4}>
              <Grid item>
                <IndicadorFlat
                  titulo="Liquido"
                  r$
                  valor={caixa.vendasProdutos.reduce(
                    (a, b) => a + b.totalLiquido,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="Quantidade"
                  un
                  valor={caixa.vendasProdutos.reduce(
                    (a, b) => a + b.quantidade,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="# Vendas"
                  valor={caixa.vendasProdutos.reduce(
                    (a, b) => a + b.contagem,
                    0,
                  )}
                />
              </Grid>
            </Grid>

            {/* <DonutChart dados={caixa.vendasProdutos.map(x => ({ name: x.produtoNome, value: x.quantidade }))} /> */}

            <List>
              {caixa.vendasProdutos.map((x) => (
                <ListItemProduto
                  key={x.produtoCod}
                  {...convertVendaProdutoToVenda(x)}
                />
              ))}
            </List>
          </TabPanel>

          <TabPanel value={tabIndex} index={3}>
            <Grid container justifyContent="center" spacing={4}>
              <Grid item>
                <IndicadorFlat
                  titulo="Liquido"
                  r$
                  valor={caixa.vendasGruposProdutos.reduce(
                    (a, b) => a + b.totalLiquido,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="Quantidade"
                  un
                  valor={caixa.vendasGruposProdutos.reduce(
                    (a, b) => a + b.quantidade,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="# Vendas"
                  valor={caixa.vendasGruposProdutos.reduce(
                    (a, b) => a + b.contagem,
                    0,
                  )}
                />
              </Grid>
            </Grid>

            <DonutChart
              dados={caixa.vendasGruposProdutos.map((x) => ({
                name: x.grupoNome,
                value: x.quantidade,
              }))}
            />

            <List>
              {caixa.vendasGruposProdutos.map((x) => (
                <ListItemGrupoProduto
                  key={x.grupoCod}
                  {...convertVendaGrupoProdutoToVenda(x)}
                />
              ))}
            </List>
          </TabPanel>

          <TabPanel value={tabIndex} index={4}>
            <Grid container justifyContent="center" spacing={4}>
              <Grid item>
                <IndicadorFlat
                  titulo="Liquido"
                  r$
                  valor={caixa.vendasFormas.reduce((a, b) => a + b.total, 0)}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="# Vendas"
                  valor={caixa.vendasFormas.reduce((a, b) => a + b.contagem, 0)}
                />
              </Grid>
            </Grid>

            <DonutChart
              dados={caixa.vendasFormas.map((x) => ({
                name: x.formaNome,
                value: x.total,
              }))}
            />

            <List>
              {caixa.vendasFormas.map((x) => (
                <ListItemFormaPgto key={x.formaNome} {...x} />
              ))}
            </List>
          </TabPanel>

          <TabPanel value={tabIndex} index={5}>
            <Grid container justifyContent="center" spacing={4}>
              <Grid item>
                <IndicadorFlat
                  titulo="Liquido"
                  r$
                  valor={caixa.vendasVendedores.reduce(
                    (a, b) => a + b.totalLiquido,
                    0,
                  )}
                />
              </Grid>
              <Grid item>
                <IndicadorFlat
                  titulo="# Vendas"
                  valor={caixa.vendasVendedores.reduce(
                    (a, b) => a + b.contagem,
                    0,
                  )}
                />
              </Grid>
            </Grid>

            <DonutChart
              dados={caixa.vendasVendedores.map((x) => ({
                name: x.vendedorNome,
                value: x.totalLiquido,
              }))}
            />

            <List>
              {caixa.vendasVendedores.map((x) => (
                <ListItemVendedor
                  key={x.vendedorCod}
                  vendaPorVendedor={convertVendaVendedorToVenda(x)}
                />
              ))}
            </List>
          </TabPanel>
        </Grid>
      </Grid>
    </div>
  );
};
